import React, { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import yup from '../../libs/yup/yup';
import CustomInput from '../../components/input/CustomInput';
import { forgotPassword } from '../../api/sportaloka-client';
import { Link, useNavigate } from 'react-router-dom';

const defaultValues = {
  email: ''
};

const schema = yup.object().shape({
  email: yup
    .string()
    .label('Alamat email')
    .email('Format alamat email salah')
    .required('${label} wajib diisi')
});

function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      const response = await forgotPassword(val.email);
      response.data.data;
      Swal.fire({
        title: 'Berhasil!',
        text: `Kami telah mengirimkan link untuk melakukan pemulihan kata sandi ke ${val.email}.`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      navigate('/');
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: 'Periksa koneksi anda dan coba kembali.',
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row justify-content-center align-items-center w-100">
      <div className="col-4">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20 w-100">
          <form className="row y-gap-20" onSubmit={handleSubmit(onSubmit)}>
            <h4 className="text-18 mb-0 pb-0 fw-600">Lupa Kata Sandi</h4>
            <p className="fw-400" style={{ lineHeight: 1.5 }}>
              Jangan khawatir, tuliskan email mu pada form dibawah ini, kami akan mengirimkan link
              ke email yang sudah didaftarkan untuk melakukan reset kata sandi akunmu.
            </p>

            <Controller
              control={control}
              name="email"
              render={({ field: { onChange, onBlur, value } }) => (
                <div className="col-12">
                  <CustomInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    type="text"
                    label="Alamat Email"
                    isError={Boolean(errors.email)}
                    errorMessage={Boolean(errors.email) && errors.email.message}
                  />
                </div>
              )}
            />

            <div className="col-12">
              <button
                disabled={loading}
                type="submit"
                className="button py-20 -dark-1 bg-blue-1 text-white w-100">
                {loading ? 'Mohon tunggu...' : 'Kirim Link'}
                {!loading && <div className="icon-arrow-top-right ml-15" />}
              </button>
            </div>

            <div className="col-12 text-center">
              <Link to="/" className="text-14 fw-500 text-blue-1 underline text-center">
                Kembali
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
